module.exports = __webpack_public_path__ + "img/vehicle-options-browse-white.07caf65d.png";